import React from 'react';
import { StyleSheet } from 'react-native';
import { useRoute } from '@react-navigation/native';
import Text from 'design-system/Text';
import { hitSlop } from 'design-system/values';
import { useAppSelector } from 'store/hooks';
import TouchableBounce from 'utils/packages/TouchableBounce';
import useConnectToSuggestedBank from '../hooks/useConnectToSuggestedBank';
import { selectConnectionSuggestionForReportAccount, selectShouldShowSuggestedConnections, } from '../selectors';
const strings = {
    tapToConnect: 'Tap to connect',
};
const ConnectSuggestedBankLabel = ({ tuAccountId }) => {
    const routeKey = useRoute().key;
    const shouldShow = useAppSelector(selectShouldShowSuggestedConnections);
    const suggestion = useAppSelector((state) => selectConnectionSuggestionForReportAccount(state, tuAccountId));
    const onConnect = useConnectToSuggestedBank(shouldShow ? suggestion : undefined, routeKey);
    if (!shouldShow || !suggestion || !onConnect)
        return null;
    return (<TouchableBounce onPress={onConnect} hitSlop={hitSlop} style={staticStyles.touchable}>
      <Text TextThin-14 Primary>
        {strings.tapToConnect}
      </Text>
    </TouchableBounce>);
};
const staticStyles = StyleSheet.create({
    touchable: {
        alignSelf: 'flex-start',
    },
});
export default React.memo(ConnectSuggestedBankLabel);
